import { ClickWjdc , GetWjdcStatus } from "@/api/Questionnaire";
const state = {
  ClickWjdc:{},
};

const mutations = {
  SET_DATA: (state, {key,data}) => {
    state[key] = data;
  }
};

const actions = {
  ClickWjdc({ commit }, params) {
    return new Promise((resolve)=>{
      ClickWjdc(params).then(res => {
        try {
          var { data } = res;
          var newData = JSON.parse(
            JSON.stringify(data.data).replace(/label/g, "text")
          );
          commit("SET_DATA", {key:'ClickWjdc',data:newData});
        } catch (error) {
          console.log(error)
        }
        resolve( res.data )
      });
    })
  },
  GetWjdcStatus({ commit }, params) {
    return new Promise((resolve)=>{
      GetWjdcStatus(params).then(res => {
        try {
          var { data } = res;
          var newData = JSON.parse(
            JSON.stringify(data.data).replace(/label/g, "text")
          );
          commit("SET_DATA", {key:'GetWjdcStatus',data:newData});
        } catch (error) {
          console.log(error)
        }
        resolve( res.data )
      });
    })
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
